/**
 * ¿HAY ANCHO PARA DIBUJAR EL CUADRO EN DOS MITADES?
 *
 * El cuadro se dibuja como en papel —las dos mitades enfrentadas y la final
 * en el medio— y así entra en la mitad del ancho. Pero en un teléfono, donde
 * se ven dos columnas por vez, esa forma se vuelve en contra: hay que
 * arrastrar hasta el centro para encontrar la final, y a mitad de camino el
 * cuadro CAMBIA DE SENTIDO DE LECTURA. Nadie lo entiende arrastrando a
 * ciegas. Angosto se dibuja en una sola dirección, de la primera ronda a la
 * final, que es un solo arrastre y siempre para el mismo lado.
 *
 * 900 px NO ES EL ANCHO EN QUE EL CUADRO ENTRA —un cuadro de 32 no entra en
 * ninguna pantalla— sino el ancho a partir del cual se ven varias columnas a
 * la vez, que es cuando la forma de dos mitades ayuda en vez de estorbar.
 *
 * SE ESCUCHA EL CAMBIO, no se mide una vez. Girar el teléfono cambia la
 * respuesta, y un cuadro que se quedó con la forma de la orientación anterior
 * es media pantalla en blanco.
 */
import { useEffect, useState } from 'react';

export const ANCHO_DE_DOS_MITADES = '(min-width: 900px)';

export function useAnchaLaPantalla(consulta: string = ANCHO_DE_DOS_MITADES): boolean {
  const [ancha, setAncha] = useState(() => medir(consulta));

  useEffect(() => {
    const mq = window.matchMedia?.(consulta);
    if (mq === undefined) return;

    // El primer `setAncha` no sobra: entre el estado inicial y este efecto
    // puede haber pasado un giro de pantalla, y en las pruebas el estado
    // inicial se calcula antes de que el doble de `matchMedia` esté puesto.
    setAncha(mq.matches);
    const escuchar = (e: MediaQueryListEvent): void => setAncha(e.matches);
    mq.addEventListener('change', escuchar);
    return () => mq.removeEventListener('change', escuchar);
  }, [consulta]);

  return ancha;
}

/**
 * `matchMedia` no existe en todos lados: en las pruebas con jsdom, y en el
 * dibujado del servidor si algún día lo hay. Sin él se contesta «angosta»,
 * que es la forma que funciona en cualquier ancho — la de dos mitades es la
 * que necesita lugar.
 */
function medir(consulta: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(consulta).matches;
}
